import React, { PureComponent } from 'react'
import AnimateHeight from 'react-animate-height'

import './info-accordion.scss'

class InfoAccordion extends PureComponent {
    onKeyPress = (e) => {
        const { toggle } = this.props
        if (e.keyCode === 13) {
            toggle()
        }
    }

    render() {
        const {
            title, show, toggle, cssClass, children, hideInfoIcon, openIcon, closeIcon,
            hideChevron, icon, infoContentClass,
            style = {},
        } = this.props
        const iconClass = icon ?? 'fa-solid fa-circle-info'
        return (
            <div className={`guide-accordion ${cssClass}`} style={style}>
                <div className="header" onClick={toggle} onKeyDown={this.onKeyPress}>
                    {!hideInfoIcon && <i className={iconClass} />}
                    <p>{title}</p>
                    {!hideChevron && <i className={`${show ? (closeIcon || 'fa-light fa-square-chevron-up') : (openIcon || 'fa-light fa-square-chevron-down')}`} />}
                </div>
                <AnimateHeight
                    className="guide-content"
                    duration={250}
                    height={show ? 'auto' : 0}
                >
                    <hr className="divider" />
                    <div className={`info-content ${infoContentClass}`}>
                        {children}
                    </div>
                </AnimateHeight>
            </div>
        )
    }
}

export default InfoAccordion
